/**
 * @desc 导入库位
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/storageUnit/importWarehousePosition`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
